import React, { useEffect, useState } from 'react';
import priceRangeBadgeBg from '../../assets/images/mengenrabatt-badge-bg.svg';
import priceRangeBadgeSm from '../../assets/images/mengenrabatt-badge-sm.svg';
import ProductImage from '../ImagesComponent/ProductImage';
import { IProduct } from '../../typings/IProduct';
import { IBioBadgeItem } from '../../typings/IBioBadges';

interface IProps {
  product: IProduct;
  isBigBadge?: boolean;
  limit?: number;
}

const BadgesList = (props: IProps) => {
  const { product, isBigBadge, limit } = props;
  const hasPriceRanges = product?.productOptions[0]?.hasPriceRanges;
  const badgesQty = product?.organicBadges?.length || 0;
  const badges: IBioBadgeItem[] = product?.organicBadges || [];
  const hasBadges = hasPriceRanges || !!badges.length;
  const isProductAvailable = !!product?.productOptions[0].availableAmount;
  const actualLimit = hasPriceRanges && limit !== undefined ? limit - 1 : limit;
  const [actualBadges, setActualBadges] = useState<IBioBadgeItem[]>([]);

  const prepareVisibleBadgesList = () => {
    if (actualLimit === undefined) {
      setActualBadges(badges);
      return;
    }
    setActualBadges(badges.slice(0, actualLimit));
  };

  useEffect(() => {
    prepareVisibleBadgesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualLimit]);

  const handleOnBlur = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    prepareVisibleBadgesList();
  };

  const handleOnFocus = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setActualBadges(badges);
  };

  const handleOnClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    if (actualBadges === badges) {
      prepareVisibleBadgesList();
      return;
    }
    setActualBadges(badges);
  };

  if (!hasBadges) {
    return <ul className="organic-items" />;
  }

  return (
    <ul
      className="organic-items"
      onMouseEnter={(e) => handleOnFocus(e)}
      onMouseLeave={(e) => handleOnBlur(e)}
      onClick={(e) => handleOnClick(e)}>
      {hasPriceRanges && isProductAvailable && (
        <>
          {!!isBigBadge && (
            <li key="priceRangeBadgeBg">
              <img src={priceRangeBadgeBg} alt="" width="50" height="50" />
            </li>
          )}
          {!isBigBadge && (
            <li key="priceRangeBadgeSm">
              <img src={priceRangeBadgeSm} alt="" width="38" height="38" />
            </li>
          )}
        </>
      )}
      {!!actualBadges.length && (
        <>
          {actualBadges.map((org: any) => (
            <li key={org.id}>
              <ProductImage key={org.id} product={{ ...org, shortDescription: '', cdnImages: [{ ...org.logo }] }} />
            </li>
          ))}
          {!!actualLimit && badgesQty > actualLimit && actualBadges !== badges && (
            <li key="limitBagesSwitcher" className="has-more">
              <span>+{badgesQty - actualLimit}</span>
            </li>
          )}
        </>
      )}
    </ul>
  );
};

export default BadgesList;
